import GtmProvider from "./GtmProvider";

export default GtmProvider;
